import { Modal, ProductCard } from "theme"; // Import the theme web component and ProductCard

var KlaviyoBackInStock = class extends HTMLElement {
  constructor() {
    super();

    this.showModalButton = this.querySelector('button[type="button"]');

    if (this.showModalButton.getAttribute('aria-controls')) {
      this.modal = document.getElementById(this.showModalButton.getAttribute('aria-controls'));
    } else {
      this.modal = this.querySelector('dialog');
    }

    this.form = this.modal.querySelector('form');

    this.variantIdInput = this.form.querySelector('[name="variant_id"]');
    this.productTitleInput = this.form.querySelector('[name="product_title"]');
    this.variantTitleInput = this.form.querySelector('[name="variant_title"]');
    this.featuredImage = this.form.querySelector('[name="featured_image"]');
    this.closeButton = this.modal.querySelector('.close-dialog');

    // Initial state check (e.g. on page load)
    this.updateVisibilityFromVariant(window.variant || {
      id: this.variantIdInput.value,
      name: this.productTitleInput.value,
      available: this.dataset.available,
      featured_image: { src: this.featuredImage.value }
    });
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('variant:change', (event) => {
      this.updateVisibilityFromVariant(event.detail.variant);
    });
    this.showModalButton.addEventListener('click', () => {
      this.modal.classList.remove('submitted');
      this.modal.showModal();
    });
    this.form.addEventListener('submit', async (e) => {
      e.preventDefault();

      await this.handleSubmit();
    });
    this.closeButton.addEventListener('click', (e) => {
      this.modal.close(); // click outside
    });

  }

  updateVisibilityFromVariant(variant) {
    if (!variant) return;
    this.dataset.available = variant.available;
    this.variantIdInput.value = variant.id;
    this.productTitleInput.value = variant.name;
    if (variant.featured_image) {
      this.featuredImage.value = variant.featured_image.src;
    }
  }

  async handleSubmit() {
    const email = this.form.querySelector('[name="email"]').value;
    const product_id = this.form.querySelector('[name="product_id"]').value;
    const restock_type = this.form.querySelector('[name="restock_type"]').value;
    const company_id = 'Sjshsj';    // AYM Klaviyo Company Id

    const variant_id = this.variantIdInput.value;
    const product_title = this.productTitleInput.value;
    const featured_image = this.featuredImage.value;

    if (window.klaviyo && window.klaviyo.track) {
      // Identify user (optional but recommended)
      window.klaviyo.identify({ email });

      const variantCompositeId = `$shopify:::$default:::${variant_id}`;
      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                  // You can include other profile attrs if you have them (first_name, last_name, etc.)
                }
              }
            },
            channels: ['EMAIL'] // or ['EMAIL','SMS'] if you also collect SMS
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: variantCompositeId
              }
            }
          }
        }
      };

      try {
        const res = await fetch(
          `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(company_id)}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'revision': '2024-06-15' // required header per docs
            },
            body: JSON.stringify(payload)
          }
        );

        // Klaviyo returns 202 on success with no body
        if (!res.ok && res.status !== 202) {
          const err = await res.json().catch(() => ({}));
          console.warn('Klaviyo BIS subscribe failed', res.status, err);
        }

        console.log('Klaviyo identify and track called');
      } catch (e) {
        console.error('Network error calling Klaviyo BIS subscribe', e);
      }
    }
    this.modal.classList.add('submitted');
  }
};

customElements.define('klaviyo-back-in-stock', KlaviyoBackInStock);


var MarketWelcomePopup = class extends Modal {
  connectedCallback() {
    super.connectedCallback();
    if (this.shouldAppearAutomatically) {
      setTimeout(() => this.show(), this.apparitionDelay);
    }
  }
  get apparitionDelay() {
    return parseInt(this.getAttribute("apparition-delay") || 0) * 1e3;
  }
  get shouldAppendToBody() {
    return false;
  }
  get shouldAppearAutomatically() {
    const query_override = new URLSearchParams(window.location.search).has('market-popup')
    return !(this.hasAttribute("only-once") && localStorage.getItem("theme:market-popup-appeared") === "true") || query_override;
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "open" && this.open) {
      localStorage.setItem("theme:market-popup-appeared", "true");
    }
  }
};
if (!window.customElements.get("market-welcome-popup")) {
  window.customElements.define("market-welcome-popup", MarketWelcomePopup);
}

const ShopifyChatWidget = class extends HTMLElement {
  constructor() {
    super();


    this.addEventListener('click', function (e) {
      e.preventDefault();
      // have to move the search for the chat widget, as it is loaded at a later time
      this.inbox = document.querySelector('#shopify-chat inbox-online-store-chat');
      this.gorgiouChatBtn = document.querySelector('#chat-button');

      if (!this.inbox && !this.gorgiouChatBtn) {
        return;
      }

      if (this.gorgiouChatBtn) {
        if (GorgiasChat.isOpen()) {
          GorgiasChat.close();
          this.gorgiouChatBtn.style.display = "none";
        } else {
          this.gorgiouChatBtn.style.display = "block";
          GorgiasChat.open();
        }
        return;
      }

      this.inbox.shadowRoot.querySelector('button').click();
      setTimeout(this.setChatCentred(), 100);
    });

  }

  setChatCentred() {
    if (!this.inbox) return;

    this.inbox.style.right = 'unset';
    this.inbox.style.left = '50%';
    this.inbox.style.transform = 'translate(-50%, 50%)';
    this.inbox.style.bottom = '50%';
    this.inbox.style.width = '50vw';
    this.inbox.style.height = '50vh';
  }
}
window.customElements.define("chat-widget", ShopifyChatWidget);


// Add init method to ProductCard prototype
ProductCard.prototype.init = function () {
  this.addVideoPreview();
};

// Add addVideoPreview method to ProductCard prototype
ProductCard.prototype.addVideoPreview = function () {
  if (!this.dataset.videoUrl) {
    return;
  }

  // Find the media element
  const mediaElement = this.querySelector('.product-card__figure');
  if (!mediaElement) {
    console.warn('Media element not found for video preview');
    return;
  }

  // Create video element
  const video = document.createElement('video');
  video.className = 'product-card__video';
  video.muted = true;
  video.loop = true;
  video.playsInline = true;
  video.preload = 'metadata';

  // Create source element
  const source = document.createElement('source');
  source.src = this.dataset.videoUrl;
  source.type = this.dataset.videoMimeType || 'video/mp4';
  video.appendChild(source);

  // Add video to media element
  mediaElement.appendChild(video);

  // Store reference for cleanup
  this._videoElement = video;

  // Setup scroll observer for this video
  this.setupVideoScrollObserver();

  // Check and add swatch behaviour
  this.setupSwatchVideoBehaviour();
};

ProductCard.prototype.setupVideoScrollObserver = function () {
  if (!this._videoElement) return;

  // Create intersection observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;

      if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
        // Video is 25% visible, start playing
        if (video.paused) {
          video.play().then(() => {
            video.classList.add('is-playing');
          }).catch(error => {
            console.warn('Video play failed:', error);
          });
        }
      } else {
        // Video is less than 25% visible, pause
        if (!video.paused) {
          video.pause();
          video.classList.remove('is-playing');
        }
      }
    });
  }, {
    threshold: [0, 0.25, 1],
    rootMargin: '0px'
  });

  // Start observing
  observer.observe(this._videoElement);

  // Store observer for cleanup
  this._videoObserver = observer;
};

ProductCard.prototype.setupSwatchVideoBehaviour = function () {
  const swatches = this.querySelector('.product-card__swatch-list');
  if (!swatches) {
    return;
  }
  swatches.addEventListener('mouseover', (e) => {
    if (!this._videoElement.paused) {
      this._videoElement.pause();
      this._videoElement.classList.remove('is-playing');
    }
  });
  swatches.addEventListener('mouseout', (e) => {
    const toElement = e.relatedTarget;
    if (!toElement || !swatches.contains(toElement)) {
      if (this._videoElement.paused) {
        this._videoElement.play().then(() => {
          this._videoElement.classList.add('is-playing');
        }).catch(error => {
          console.warn('Video play failed:', error);
        });
      }
    }
  });
}

// Override connectedCallback to call init
const originalConnectedCallback = ProductCard.prototype.connectedCallback;
ProductCard.prototype.connectedCallback = function () {
  if (originalConnectedCallback) {
    originalConnectedCallback.call(this);
  }
  this.init(); // Call our custom init method
};

// Store original disconnected callback before overriding
const originalDisconnectedCallback = ProductCard.prototype.disconnectedCallback;

// Add cleanup method for disconnecting observers
ProductCard.prototype.disconnectedCallback = function () {
  // Disconnect video observer
  if (this._videoObserver) {
    this._videoObserver.disconnect();
    this._videoObserver = null;
  }

  // Call original disconnected callback if it exists
  if (originalDisconnectedCallback) {
    originalDisconnectedCallback.call(this);
  }
};

// Also initialize any existing ProductCard elements
function initializeExistingProductCards() {
  const existingCards = document.querySelectorAll('product-card');

  existingCards.forEach((card, index) => {
    if (card.init && typeof card.init === 'function') {
      card.init();
    }
  });
}

// Initialize existing cards immediately if DOM is ready, or when it loads
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeExistingProductCards);
} else {
  initializeExistingProductCards();
}